import { useContext } from "react";

import Box from "@/components/Box";
import Circle from "@/components/Circle";
import DataLoader from "@/components/DataLoader";
import OrdersAndTests from "@/components/OrdersAndTests";
import PartnerDashboardBox from "@/components/boxes/PartnerDashboardBox";
import OrderIcon from "@/components/orders/OrderIcon";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import Group from "@/tpo/Group";
import { ViewerContext } from "@/tpo/Viewer";
import { useTheme } from "styled-components";

import Template from "../shared/Template";
import { PATIENT_ORDERS_AND_TESTS } from "./graphql";
import usePatientTestsAndReports from "./usePatientTestsAndReports";

export default function TestsRoute({ templateProps }) {
  const { userId } = useContext(ViewerContext);
  const theme = useTheme();
  const { organisationId } = useOrganisationContext();
  const patientTestsAndReports = usePatientTestsAndReports();

  return (
    <Template selectedTab="tests" docTitle="Patient's tests" {...templateProps}>
      <Box px={20}>
        <PartnerDashboardBox
          mt={theme.spacing.section.pt}
          mb={theme.spacing.section.pb}
          pt={theme.spacing.figma.medium}
          pb={theme.spacing.figma.large}
        >
          <Group alignItems="center" gap={20}>
            <Circle size={60} background="white" withBorder borderWidth={2}>
              <OrderIcon width={[30, 30, 40]} variant="outline" />
            </Circle>
            <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
              Tests
            </Box>
          </Group>
          <DataLoader
            query={PATIENT_ORDERS_AND_TESTS}
            variables={{
              organisationId,
              userId,
              allTests: true,
              includeUnapproved: true
            }}
            skip={!organisationId}
            render={({ ordersInProgress, userTests }) => (
              <OrdersAndTests
                ordersInProgress={ordersInProgress}
                userTests={userTests}
                {...patientTestsAndReports}
              />
            )}
          />
        </PartnerDashboardBox>
      </Box>
    </Template>
  );
}
